/* eslint-disable */
import { Navigate, useRoutes } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
//
import Login from './pages/Login';
import Register from './pages/Register';
import DashboardApp from './pages/DashboardApp';
import Products from './pages/Products';
import Blog from './pages/Blog';
import User from './pages/User';
import NotFound from './pages/Page404';
import Order from './pages/Order';
import Approve from './pages/Approve';
import Checkorder from './pages/Checkorder';
import Deliver from './pages/Deliver';
import Checkproduct from './pages/Checkproduct';
import Plant from './pages/Plant';
import Pantry from './pages/Pantry';
import Admin from './pages/Admin';
import Usergroup from './pages/Usergroup';
import OrderProduct from './pages/OrderProduct';
import DeliverProduct from './pages/DeliverProduct';
import ApproveProduct from './pages/ApproveProduct';
import CheckVendor from './pages/CheckVendor';
import CheckPickup from './pages/CheckPickup';
import PlantProduct from './pages/PlantProduct';
import PantrytProduct from './pages/PantryProduct';
import AdminProduct from './pages/AdminProduct';
import UserGroupProduct from './pages/UserGroupProduct';
import OrderPopup from './pages/OrderPopup';
import Stock from './pages/Stock';
import Product from './pages/Product';
import Contact from './pages/Contact';
import Billing from './pages/Billing';
import Picking from './pages/Picking';
import Post from './pages/Post';
import Newpost from './pages/Newpost';
import Report from './pages/Report';
import BackLog from './pages/BackLog';
import Example from './pages/Example';
import CreateProduct from './pages/CreateProduct';
import Quotation from './pages/Quotation';
import QuotationProduct from './pages/QuotationProduct';
import QuotationPopup from './pages/QuotationPopup';
import DeliverPopup from './pages/DeliverPopup';
import CheckorderBy from './pages/CheckorderBy';
import CheckproductBy from './pages/CheckproductBy';
import ApproveBy from './pages/ApproveBy';
import CheckVendorPopup from './pages/CheckVendorPopup';
import ResetData from './pages/ResetData';
import RecoveryData from './pages/RecoveryData';
import ManualUser from './pages/ManualUser';
import ManualAdmin from './pages/ManualAdmin';
import ContractExpired from './pages/ContractExpired';
import ConfigExpired from './pages/ConfigExpired';
import { useEffect } from 'react';
import { httpClient } from './utils/HttpClient';
import { useLogin } from './hooks/useLogin';

export default function Router(props) {
  const login = useLogin();
  useEffect(() => {
    const checkExpired = async () => {
      const result = await httpClient.get('expired');
      if (result.data.expired) {
        login.setExpired(true);
      } else {
        login.setExpired(false);
      }
    };
    checkExpired();
  }, []);

  return useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/login" replace /> },
        {
          path: 'app',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <DashboardApp />
            </ProtectedRoute>
          )
        },
        {
          path: 'quotation',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Quotation props />
            </ProtectedRoute>
          )
        },
        {
          path: 'quotationProduct',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <QuotationProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'quotationProduct/:id',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <QuotationProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'quotationpopup',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <QuotationPopup props />
            </ProtectedRoute>
          )
        },
        {
          path: 'user',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <User />
            </ProtectedRoute>
          )
        },
        {
          path: 'products',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Products />
            </ProtectedRoute>
          )
        },
        {
          path: 'blog',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Blog />
            </ProtectedRoute>
          )
        },
        {
          path: 'order',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Order props />
            </ProtectedRoute>
          )
        },
        {
          path: 'approve/:plant/:order/:status',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <Approve props />
            </ProtectedRoute>
          )
        },
        {
          path: 'approveby',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <ApproveBy props />
            </ProtectedRoute>
          )
        },
        {
          path: 'checkorder/:plant/:order/:status',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <Checkorder props />
            </ProtectedRoute>
          )
        },
        {
          path: 'checkorderby',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <CheckorderBy props />
            </ProtectedRoute>
          )
        },
        {
          path: 'deliver',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Deliver props />
            </ProtectedRoute>
          )
        },
        {
          path: 'checkproduct/:plant',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <Checkproduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'checkproductby',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <CheckproductBy props />
            </ProtectedRoute>
          )
        },
        {
          path: 'plant',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Plant props />
            </ProtectedRoute>
          )
        },
        {
          path: 'pantry',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Pantry props />
            </ProtectedRoute>
          )
        },
        {
          path: 'admin/:type',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Admin props />
            </ProtectedRoute>
          )
        },
        {
          path: 'adminproduct/:type',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <AdminProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'adminproduct/:type/:id',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <AdminProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'usergroup',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Usergroup props />
            </ProtectedRoute>
          )
        },
        {
          path: 'orderproduct',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <OrderProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'orderproduct/:id',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <OrderProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'deliverproduct',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <DeliverProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'deliverpopup',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <DeliverPopup props />
            </ProtectedRoute>
          )
        },
        {
          path: 'deliverproduct/:id',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <DeliverProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'approveproduct',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <ApproveProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'approveproduct/:id',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <ApproveProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'checkvendor',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <CheckVendor props />
            </ProtectedRoute>
          )
        },
        {
          path: 'checkvendor/:id',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <CheckVendor props />
            </ProtectedRoute>
          )
        },
        {
          path: 'checkvendorpopup',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <CheckVendorPopup props />
            </ProtectedRoute>
          )
        },
        {
          path: 'checkpickup',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <CheckPickup props />
            </ProtectedRoute>
          )
        },

        {
          path: 'checkpickup/:id',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <CheckPickup props />
            </ProtectedRoute>
          )
        },
        {
          path: 'plantproduct',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <PlantProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'plantproduct/:id',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <PlantProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'pantryproduct',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <PantrytProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'pantryproduct/:id',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <PantrytProduct props />
            </ProtectedRoute>
          )
        },

        {
          path: 'usergroupproduct',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <UserGroupProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'usergroupproduct/:id',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <UserGroupProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'orderpopup',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <OrderPopup props />
            </ProtectedRoute>
          )
        },
        {
          path: 'stock',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Stock props />
            </ProtectedRoute>
          )
        },
        {
          path: 'product/:type',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Product props />
            </ProtectedRoute>
          )
        },
        {
          path: 'createproduct',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <CreateProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'createproduct/:id',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <CreateProduct props />
            </ProtectedRoute>
          )
        },
        {
          path: 'contact',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Contact props />
            </ProtectedRoute>
          )
        },
        {
          path: 'reportbilling',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Billing props />
            </ProtectedRoute>
          )
        },
        {
          path: 'picking',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Picking props />
            </ProtectedRoute>
          )
        },
        {
          path: 'newpost',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <Newpost props />
            </ProtectedRoute>
          )
        },
        {
          path: 'newpost/:type',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Newpost props />
            </ProtectedRoute>
          )
        },
        {
          path: 'post/:type',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <Post props />
            </ProtectedRoute>
          )
        },
        {
          path: 'post/:type/:id',
          element: (
            <ProtectedRoute checkMenuPermission={false}>
              <Post props />
            </ProtectedRoute>
          )
        },
        {
          path: 'reportsummary',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Report props />
            </ProtectedRoute>
          )
        },
        {
          path: 'backlog',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <BackLog props />
            </ProtectedRoute>
          )
        },
        {
          path: 'reportorder',
          element: (
            <ProtectedRoute checkMenuPermission={true}>
              <Example props />
            </ProtectedRoute>
          )
        }
      ]
    },
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { index: true, element: <Navigate to={`/login?ts=${Date.now()}`} replace /> },
        {
          path: 'login',
          element: (
            <ProtectedRoute>
              <Login />
            </ProtectedRoute>
          )
        },
        { path: 'register', element: <Register /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" replace /> },
        {
          path: 'reset',
          element: <DashboardLayout />,
          children: [
            {
              element: (
                <ProtectedRoute checkMenuPermission={true}>
                  <ResetData props />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          path: 'recovery',
          element: <DashboardLayout />,
          children: [
            {
              element: (
                <ProtectedRoute checkMenuPermission={true}>
                  <RecoveryData props />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          path: 'manual_user',
          element: <DashboardLayout />,
          children: [
            {
              element: (
                <ProtectedRoute checkMenuPermission={true}>
                  <ManualUser props />
                </ProtectedRoute>
              )
            }
          ]
        },
        {
          path: 'manual_admin',
          element: <DashboardLayout />,
          children: [
            {
              element: (
                <ProtectedRoute checkMenuPermission={true}>
                  <ManualAdmin props />
                </ProtectedRoute>
              )
            }
          ]
        }
      ]
    },
    { path: `/expired`, element: <ConfigExpired props /> },
    { path: '/newpost', element: <Newpost props /> },
    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}
